import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, Banknote, Brain, Factory } from 'lucide-react';
import { Button } from './ui/button';

const IndustrySection = () => {
  const industries = [
    {
      icon: ShoppingCart,
      title: 'E-commerce',
      description: 'Scalable, high-performance platforms for seamless customer experiences',
      path: '/solutions/ecommerce',
    },
    {
      icon: Banknote,
      title: 'FinTech',
      description: 'Secure, compliant infrastructure for financial services innovation',
      path: '/solutions/fintech',
    },
    {
      icon: Brain,
      title: 'AI & Machine Learning',
      description: 'Accelerate innovation with AI and machine learning solutions powered by AWS.',
      path: '/solutions/ai-ml',
    },
    {
      icon: Factory,
      title: 'Manufacturing',
      description: 'IoT-enabled smart factories with real-time data analytics',
      path: '/solutions/manufacturing',
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-[#061426] to-[#020B1A]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Industry-Specific Solutions
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Tailored AWS architectures for your industry's unique challenges
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {industries.map((industry, index) => {
            const Icon = industry.icon;
            return (
              <Link 
                key={index}
                to={industry.path}
                className="bg-gradient-to-br from-[#061426] to-[#0A1E3F] border border-cyan-500/20 rounded-xl p-8 shadow-md transition-all duration-300 hover:border-cyan-400 hover:shadow-2xl hover:-translate-y-2 group block"
                style={{ boxShadow: '0 4px 20px rgba(0, 212, 255, 0.1)' }}
              >
                <div className="w-14 h-14 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" style={{ boxShadow: '0 0 20px rgba(0, 212, 255, 0.3)' }}>
                  <Icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3">{industry.title}</h3>
                <p className="text-gray-400 leading-relaxed">{industry.description}</p>
              </Link>
            );
          })}
        </div>

        <div className="text-center">
          <Link to="/contact">
            <Button className="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white font-medium px-8 py-6 text-lg transition-all duration-300" style={{ boxShadow: '0 0 30px rgba(0, 212, 255, 0.4)' }}>
              Explore All Solutions
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default IndustrySection;